import React, { Component } from 'react';
import '../App.css';

var cssobj = {
  backgroundSize:'cover',
  backgroundRepeat:'no-repeat',
}
class Pic extends Component {

  render() {
    return (
      <div className="pic" style={cssobj}>

      </div>
    );
  }
}

export default Pic;



// WEBPACK FOOTER //
// ./src/components/pic.js